import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Layout, Row, Col, Typography, Spin, Input } from 'antd';
import { Icon } from 'antd-mobile';
import { withTranslation } from 'react-i18next';
import FooterMenu from '../../components/Guest/Footer/Footer';
import './guestGuideDocument.css';

const { Content } = Layout;
const { Text } = Typography;
const { Search } = Input;

@inject(
    'guideDocumentStore'
)
@observer
class GuestGuideDocumentPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        this.props.guideDocumentStore.initGuestGuideDocument();
    }

    componentWillUnmount() {
        this.props.guideDocumentStore.setSearchByTitle('');
    }

    // ON CLICK

    backToHomePageOnClick = () => {
        this.props.history.push('/')
    }

    guideDocumentTitleOnClick = (url) => {
        window.open(url, "_self");
    }

    render() {
        const history = this.props.history;
        const {
            readLoading,
            guestGuideDocumentsFilter,
            searchByTitle,
        } = this.props.guideDocumentStore;

        return (
            <Layout className='layout-page'>
                <Content>
                    <Row>
                        <Col span={24} className='col-header'>
                            <Row>
                                <Col span={4} className='col-header-back' onClick={this.backToHomePageOnClick}>
                                    <Icon type="left" size='lg' color='#FFF' />
                                </Col>
                                <Col span={16} className='col-header-text'>
                                    <Text className='text-header'>Guide Document</Text>
                                </Col>
                                <Col span={4} />
                            </Row>
                        </Col>
                    </Row>
                    <React.Fragment>
                        {
                            readLoading && guestGuideDocumentsFilter.length === 0
                                ?
                                <Row>
                                    <Col span={24} className='guestguidegocument-col-nodata'>
                                        <Spin spinning={true} tip={'Loading Data'} />
                                    </Col>
                                </Row>
                                :
                                <React.Fragment>

                                    <Row className='row-body-content'>
                                        <Col span={24} className='guestguidegocument-row-search'>
                                            <Search placeholder={'Search'} value={searchByTitle} onChange={(e) => this.props.guideDocumentStore.setSearchByTitle(e.target.value)} />
                                        </Col>
                                        <Col span={24}>
                                            <Row>
                                                <Col span={1} />
                                                <Col span={22}>
                                                    <Row className='guestguidegocument-row-list'>
                                                        <Col span={24} className='guestguidegocument-col-title'>Document</Col>
                                                    </Row>
                                                    {guestGuideDocumentsFilter.map((item) => (
                                                        <Row className='row-tvchannel-list' key={item.guideDocumentID}>
                                                            <Col span={24} className='guestguidegocument-col-data' onClick={() => this.guideDocumentTitleOnClick(item.url)}><a href='javascript:void(0);'>{item.title}</a></Col>
                                                        </Row>
                                                    ))}
                                                </Col>
                                                <Col span={1} />
                                            </Row>
                                        </Col>
                                    </Row>
                                </React.Fragment>
                        }
                    </React.Fragment>
                    <FooterMenu history={history} />
                </Content>
            </Layout>
        )
    }
}

export default withTranslation()(GuestGuideDocumentPage)